import { faClipboardCheck, faIdCard, faUserPlus, faKey, faBell } from '@fortawesome/free-solid-svg-icons';

// Groups every notificationType (see notification.service.ts / schedule.service.ts /
// validateEmployeeChecks.ts / notifyFollowers.ts / allKeys.service.ts for where each is set) into
// one of a handful of user-facing categories. Every type in a category shares one label/icon/color
// - a duty status change and a new duty both read "Schedule Notification" in the same color,
// rather than each duty sub-type getting its own shade despite sharing a label.
const CATEGORIES = {
  schedule: {
    label: 'Schedule Notification', icon: faClipboardCheck, color: '#0091ae', bg: '#e6fbfd',
    types: ['new duty', 'duty status', 'duty time updated', 'duty decline'],
  },
  key: {
    label: 'Key Register Notification', icon: faKey, color: '#d97706', bg: '#fffbeb',
    types: ['key'],
  },
  employee: {
    label: 'Employee Notification', icon: faIdCard, color: '#7c3aed', bg: '#f5f0ff',
    types: ['visa', 'skill'],
  },
  follow: {
    label: 'Follow Notification', icon: faUserPlus, color: '#16a34a', bg: '#f0fdf4',
    types: ['follow'],
  },
};

const TYPE_TO_CATEGORY = Object.values(CATEGORIES).reduce((map, category) => {
  category.types.forEach((type) => { map[type] = category; });
  return map;
}, {});

const DEFAULT_META = { icon: faBell, color: '#516f90', bg: '#eef2f6', label: 'General Notification' };

export const getNotificationMeta = (notificationType) =>
  TYPE_TO_CATEGORY[String(notificationType || '').toLowerCase().trim()] || DEFAULT_META;
